import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFailure = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "success-icon",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				id: "Ellipse 47",
				cx: 21.0003,
				cy: 21.0003,
				r: 20.5882,
				fill: "#F73B3B",
				fillOpacity: .2
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group 3906",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "Line 3",
					d: "M26 26L16 16",
					stroke: "#F73B3B",
					strokeWidth: 2
				}), /* @__PURE__ */ _jsx("path", {
					id: "Line 4",
					d: "M16 26L26 16",
					stroke: "#F73B3B",
					strokeWidth: 2
				})]
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Ellipse 86",
				d: "M40.2172 17.2042C41.0846 21.5951 40.4221 26.1506 38.3401 30.1126C36.258 34.0745 32.882 37.204 28.7737 38.9802C24.6655 40.7563 20.0729 41.072 15.7603 39.8747C11.4477 38.6774 7.67519 36.0393 5.07058 32.3995C2.46598 28.7597 1.18639 24.3377 1.44478 19.8695C1.70317 15.4012 3.48395 11.1562 6.49076 7.8409C9.49757 4.5256 13.549 2.33998 17.9709 1.64779C22.3928 0.955591 26.9184 1.79857 30.7945 4.03643",
				stroke: "#F73B3B",
				strokeWidth: 2,
				strokeLinecap: "round"
			})
		]
	})
});
export default SvgFailure;
